// src/context/CompanyContext.js
import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useFetchData } from '../utilities/Actions/Hooks';
import { BaseUrlContext } from './BaseUrlContext';

export const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const { baseUrl, config } = useContext(BaseUrlContext);
  const [companyToken, setCompanyToken] = useState({});
  const [companyInfo, setCompanyInfo] = useState({});
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });


  const navigate = useNavigate();
  const fetchCompanyInfo = async (token) => {
    try {
      const res = await axios.get(`${baseUrl}/api/auth/getCompanyInfo`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setCompanyInfo(res.data); // ✅ Save only the company info
      console.log("Company Info Response:", res.data);
      return res.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setAlert({ show: true, type: "danger ", message: "Unauthorized: Invalid credentials" });
      }
      else {
        setAlert({ show: true, type: "danger ", message: "Login failed. Please check your network or try again." });
      }
    }
  };
  const loginCompany = async (userData, validateCompanyUser, setErrors) => {
    const validationErrors = validateCompanyUser(userData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    try {
        setAlert({show: true, type: "info",   message: "Logging in...",  });
      const loginUrl = `${baseUrl}/api/auth/login`;
      const res = await axios.post(loginUrl, userData);

      if (res.status === 200) {
        const token = res.data;
        setCompanyToken(token);

        const companyData = await fetchCompanyInfo(token); 
        if (companyData) {
       setAlert({ show: true, type: "success", message: "Logged in successfully" });

          const redirectTo = localStorage.getItem("redirectAfterLogin") || `${config.appBase}/?token=${token}`;

          localStorage.removeItem("redirectAfterLogin");

          window.location.href = redirectTo;
        } else {
          setAlert({ show: true, type: "danger ", message: "Login failed. Please check your network or try again." });
          
        }
        // const queryParams = new URLSearchParams({ coCode: companyData.coCode, userName: companyData.registeredEmail,companyName: companyData.companyNameEng, }).toString();

      } else {
        setAlert({ show: true, type: "danger ", message: "Invalid username or password!" });
      }
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);

      if (error.response && error.response.status === 401) {
        setAlert({ show: true, type: "danger ", message: "Unauthorized: Invalid credentials" });
      } else if (error.response && error.response.status === 500) {
        setAlert({ show: true, type: "danger ", message: "Server error. Please try again later." });
      } else {
        setAlert({ show: true, type: "danger ", message: "Login failed. Please check your network or try again." });
      }
    }
  };


  return (
    <CompanyContext.Provider
      value={{
        companyToken,
        companyInfo,
        alert,
        setAlert,
        loginCompany,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};
